import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/banner/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/banner/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/banner/updateById', data)
}
export function updateStatus (data) {
  return request.post('/business/banner/updateStatus', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/banner/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/banner/delete/batch', {
    params: {
      ids
    }
  })
}
